// Chrome metrics shared by the bars at the top of a screen, as in the design's
// shell, so a bar is the same height wherever it appears.
export const layout = {
  appBarHeight: 60,
  /** The account avatar that sits in a bar. */
  barAvatarSize: 36,
} as const;

export default layout;
